import Vue from "vue";
import App from "./App.vue";
import Eagle from "eagle.js";
import "animate.css/animate.min.css";
import "./style/theme.scss";
import Router from "vue-router";
// import MathGraphs from "math-graphs";

Vue.use(Eagle);
Vue.use(Router);
// Vue.use(MathGraphs);

const appRoute = {
  component: App,
  props: {
    onEndExit: () => {},
    onStartExit: () => {},
  },
};

new Vue({
  router: new Router({
    routes: [
      {
        path: "/:slide/:step",
        ...appRoute,
      },
      {
        path: "*",
        ...appRoute,
      },
    ],
  }),
  render: (h) => h("router-view"),
}).$mount("#app");
